import { Tab, Tabs } from "@material-ui/core";
import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class TabNav extends Component {
  state = {
    selected: this.props.index,
    tabs: this.props.tabs,
  };

  componentDidMount() {
    console.log(this.props);
  }

  handleChange = (event, newValue) => {
    this.setState({ selected: newValue });
  };

  render() {
    return (
      <nav
        id="secondary-navigation"
        className="navbar__secondary"
        role="navigation"
      >
        <Tabs
          value={this.state.selected}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          {this.state.tabs.map((t, index) => {
            return (
              <NavLink to={t.path} key={index}>
                <Tab label={t.label} />
              </NavLink>
            );
          })}
        </Tabs>
      </nav>
    );
  }
}
export default TabNav;
